import firebase from 'firebase'
import React from 'react'

function ExclusiontList({ exclusions, handleRemoveExclusion }) {
  return (
    <div>
      {exclusions.length > 0 && (
        <div className="date-section">
            <h5>Excluded Dates</h5>
            {exclusions.map((item) => (
            <div key={item.id} className="date-item excluded">
                {/* Convert the date to a string before rendering */}
                {item.date instanceof firebase.firestore.Timestamp
                  ? item.date.toDate().toLocaleDateString()  // Using toLocaleDateString to format the date
                  : item.date.toLocaleDateString() // Ensure that it is formatted as a string
                }
                <button
                    className="btn-remove"
                    onClick={() => handleRemoveExclusion(item)}
                >
                ×
                </button>
            </div>
            ))}
        </div>
      )}
    </div>
  )
}

export default ExclusiontList
